module.exports = __webpack_public_path__ + "./docs/img/icon-api_method.ea5884c598e40b3360650e2e723c42f6.svg";